var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-10"},[_c('div',{staticClass:"col span-6"},[_c('LabeledSelect',{attrs:{"mode":_vm.mode,"disabled":_vm.isEdit,"options":_vm.clusterOptions,"required":true,"label":_vm.t('cluster.credential.harvester.cluster')},model:{value:(_vm.cluster),callback:function ($$v) {_vm.cluster=$$v},expression:"cluster"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }